<script lang="ts" setup>
import { LocationQuery, useRoute, useRouter } from 'vue-router'
const router = useRouter()
import { ElLoading } from "element-plus";
import { onMounted } from 'vue'
import { authUser } from "@/api/oauth";
import { useUserStore } from "@/stores/user";
const userStore = useUserStore();
import { createDesign } from '@/api/affairs'
onMounted(async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '正在验证用户信息...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  try {
    const query = router.currentRoute.value.query
    const result = await authUser({ token: query.token })

    if (result.data.code == 200) {
      console.log('result', result.data.data)

      const userResult = result.data.data
      userResult.access_token = query.token as string
      console.log('userResult', (JSON.stringify(userResult)))
      userStore.setAuthData(userResult);
      if (query.template_id) {
        router.replace({
          path: '/editor',
          query: {
            id: query.template_id,
            mode: "user"
          }
        })
      } else {
        const res = await createDesign({
          height: 1000,
          template_id: 0,
          name: '未命名模板',
          width: 1000,
        })
        const params = {
          id: String(res.data?.data?.pk ?? ''),
          mode: 'create',
          category_id: '0',
          type: 'poster',
          width: String(1000 ?? ''),
          height: String(1000 ?? ''),
          unit: String('px'),
          dpi: '300'
        }
        router.replace({
          path: '/editor',
          query: params
        })
        // window.open(`/editor?${params.toString()}`, '_blank')
      }

    }

    loadingInstance.close()
  } catch (error) {
    loadingInstance.close()
  }
})
</script>